const Confirm = {
  install(Vue) {
    Vue.prototype.$confirm = function alert(title, message, options = {}) {
      const defaultCatch = options.hasOwnProperty('catch') ? options.catch : true
      const skipReject = options.hasOwnProperty('reject') ? !options.reject : true
      const promise = new Promise((resolve, reject) => {
        if (window.confirm(message)) {
          resolve()
        } else if (!skipReject) {
          reject()
        }
      })
      if (defaultCatch) promise.catch(() => null) /* Default catch to avoid console warnings */
      return promise
    }
  },
}

export default Confirm
